<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct" id="toc_marker-1">This Isn’t a Game</p>
<p class="Book-Author" xml:lang="en-GB">David Moss</p>
<p class="Book-Publisher para-style-override-1" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="Body-Center"><span><img alt="PPPlogo.jpg" class="frame-1" src="image/PPPlogo_fmt.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// This_Isnt_A_Game.vue?4b1b2bf0